module.exports = __webpack_public_path__ + "img/mk.2413b107.svg";